<template>
  <v-menu :close-on-content-click="false" content-class="rounded-lg" min-width="200" offset-y right>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!isSharedPhonebook" class="mx-1" color="grey" fab outlined v-bind="attrs" x-small v-on="on">
        <v-icon color="blue lighten-2">mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card class="rounded-lg" flat>
      <v-card-title class="pb-1">
        مدیریت برچسب ها
      </v-card-title>
      <v-list class="transparent pa-0" dense>
        <contacts-tags :tag-list="tagList" immediate picker/>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import ContactsTags from "./contactsTags.vue";
import {mapGetters} from "vuex"

export default {
  name: "contactsEditTags",

  components: {ContactsTags},

  props: {
    tagList: Array
  },

  computed: {
    ...mapGetters('phonebook', ['isSharedPhonebook'])
  }
}
</script>

<style scoped>

</style>